import { InjectionToken } from '@angular/core';


export interface AppConfig {
	envName: string;
	buildVer: string;
	appVersion: string;
	insightKey: string;
	domainPatientAPI: string;
	domainUserAPI: string;
	domainAdminAPI: string;
	domainImageAPI: string;
	domainRayAPI: string;
	domainIntegrationAPI: string;
	domainTlhexAPI: string;
	domainAiAPI: string;
	cdnUrl: string;
	sseAPI: string;
	b2cTenantName: string;
	b2cTenantId: string;
	b2cSignInPolicyId: string;
	b2cResetPasswordPolicyId: string;
	b2cChangePasswordPolicyId: string;
	b2cClientId: string;
	b2cApplicationScope: string;
	appSSOutUriApi: string;
	idleTimeToEndSession: number;
	validMIMETypes: string[];
	maxAttachmentSize: number;
	resetSubscriptionTimeout: number;
	nextraySite: string;
	nextrayViewSite: string;
	fitboneSite: string;
	fitboneViewSite: string;
	tlhexSite: string;
	tlhexViewSite: string;
	legalTermsSite: string;
	legalTermsAcceptSite: string;
	aboutSite: string;
	guideSite: {
		baseUrl: string;
		list: string;
	};
	helpSite: {
		baseUrl: string;
		fileNames: string;
	};
	customerCareEmail: string;
	tspSite: string;
	eifuSite: string;
	cookieName: string;
	cookiePolicyId: number;
	cookieSiteId: number;
}

export const APP_CONFIG = new InjectionToken<AppConfig>('AppConfig');

let appConfig: AppConfig;

export function initializeAppConfig(config: AppConfig) {
	appConfig = config;
}

export function getAppConfig(): AppConfig {
	if (!appConfig) {
		throw new Error('AppConfig not initialized!');
	}
	return appConfig;
}


export enum PAGE {
	ERROR = 'error',
	DASHBOARD = 'dashboard',
	LIST = 'list',
	LIST_PLANS = 'list/plans',
	LIST_RECEIVED = 'list/received',
	LIST_ONLY_PLANS = 'list/onlyplans',
	LIST_ARCHIVE = 'list/archive',
	PATIENT_NEW = 'patient/new',
	PATIENT_EDIT = 'patient/edit',
	PLAN_NEW = 'plan/new',
	PLAN_EDIT = 'plan/edit',
	PROFILE_EDIT = 'profile/edit'
}